import { useCallback } from 'react';

import useAppSelector from '@webclient/hooks/useAppSelector';
import usePaymentWithStripe from '@webclient/hooks/usePaymentWithStripe';

type PlansKindType =
  | 'creditPack'
  | 'geniusSearchMonthly'
  | 'geniusSearchYearly'
  | 'geniusTeamsYearly'
  | 'geniusTeamsMonthly';

const CREDIT_PACK_PRICE_ID = String(import.meta.env.VITE_CREDIT_PACK);
const GENIUS_SEARCH_PLAN_MONTHLY_PRICE_ID = String(
  import.meta.env.VITE_GENIUS_SEARCH_PLAN_MONTHLY,
);
const GENIUS_SEARCH_PLAN_YEARLY_PRICE_ID = String(
  import.meta.env.VITE_GENIUS_SEARCH_PLAN_YEARLY,
);
const GENIUS_TEAMS_PLAN_MONTHLY_PRICE_ID = String(
  import.meta.env.VITE_GENIUS_TEAMS_PLAN_MONTHLY,
);
const GENIUS_TEAMS_PLAN_YEARLY_PRICE_ID = String(
  import.meta.env.VITE_GENIUS_TEAMS_PLAN_YEARLY,
);

export default function usePlanHandler() {
  const { isStripeRequestPending, handleRedirectToStripe } =
    usePaymentWithStripe();
  const isUserAuthenticated = useAppSelector(
    (state) => state.auth.isUserAuthenticated,
  );
  const isPending = isStripeRequestPending || !isUserAuthenticated;

  const handleRedirectUserToRequiredPlan = useCallback(
    (planKind: PlansKindType) => {
      return (_event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        switch (planKind) {
          case 'creditPack':
            handleRedirectToStripe({
              priceId: CREDIT_PACK_PRICE_ID,
              mode: 'payment',
            });
            break;
          case 'geniusSearchMonthly':
            handleRedirectToStripe({
              priceId: GENIUS_SEARCH_PLAN_MONTHLY_PRICE_ID,
              mode: 'subscription',
            });
            break;
          case 'geniusSearchYearly':
            handleRedirectToStripe({
              priceId: GENIUS_SEARCH_PLAN_YEARLY_PRICE_ID,
              mode: 'subscription',
            });
            break;
          case 'geniusTeamsMonthly':
            handleRedirectToStripe({
              priceId: GENIUS_TEAMS_PLAN_MONTHLY_PRICE_ID,
              mode: 'subscription',
            });
            break;
          case 'geniusTeamsYearly':
            handleRedirectToStripe({
              priceId: GENIUS_TEAMS_PLAN_YEARLY_PRICE_ID,
              mode: 'subscription',
            });
            break;
          default:
            planKind satisfies never;
        }
      };
    },
    [handleRedirectToStripe],
  );

  return {
    handleRedirectUserToRequiredPlan,
    isPending,
  };
}
